import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { profilesActions } from '@actions';
import { isDirectoryPlatformId } from '@helpers/directories';
import { useSyncProfilesFilters } from './useSyncProfilesFilters';

export const useLocationDirectoriesCount = (locationId, enabled = true) => {
    const dispatch = useDispatch();
    const { getPlatformsValues } = useSyncProfilesFilters();

    useEffect(() => {
        if (enabled && locationId) {
            dispatch(profilesActions.getFilterData());
        }
    }, [enabled, locationId, dispatch]);

    return useMemo(
        () => (enabled && locationId ? getPlatformsValues([locationId]).filter(isDirectoryPlatformId).length : 0),
        [enabled, locationId, getPlatformsValues],
    );
};
